export default {
  SEARCH_POST_CODE: 'pc',
  SEARCH_LANGUAGE_PREF: 'searchlangpref',
  VIEW_TYPE: 'lrpViewOption',
  ADOBE_IDENTIFIER: 'aam_uuid',
  RSI_SEGMENTS: 'rsi_segs',
  RESULTS_PER_PAGE: 'ResultsPerPage',
  SHOPPING_CART_TOTAL_PRODUCTS: 'MpShoppingCartTotalProducts',
};
